module.exports = __webpack_public_path__ + "img/系统介绍.57cd8ce2.jpg";